// extracted by mini-css-extract-plugin
export default {"componentWrapper":"BottomMenu_componentWrapper__-XOl-","menuItem":"BottomMenu_menuItem__7Zokg","active":"BottomMenu_active__D3k1H"};